import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/bg.png'
import _imports_2 from '@/assets/img/bg2.png'
import _imports_3 from '@/assets/img/icon1.png'
import _imports_4 from '@/assets/img/icon2.png'


const _withScopeId = n => (_pushScopeId("data-v-f67000ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header w_1200" }
const _hoisted_2 = { class: "header_top" }
const _hoisted_3 = { class: "header_top_main" }
const _hoisted_4 = { class: "header_content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-img--list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "综合素质评价", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "综合素质课程", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

import { publicPreviewImg } from "@/apis/home";
import { onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  props: {
  menus: {
    type: Object,
    default: {},
  },
  topPic: {
    type: Object,
    default: {},
  },
  alerts: {
    type: Array,
    default: () => [],
  },
  notice: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {

let keyWord = ref(null);
const props = __props;

const router = useRouter();
const route = useRoute();

const goHome = () => {
  router.push({ path: "/" });
};
const goOther = () => {
  window.open("https://yjszhsz.scu.edu.cn/");
};
const goSearch = () => {
  if (keyWord.value) {
    router.push({ path: "/list/news/ ", query: { keyWord: keyWord.value } });
  } else {
    ElMessage.error("请输入查询关键字");
  }
};
const goDetail = (item: any) => {
  if (
    item.menuUrl.substr(0, 4) == "http" ||
    item.menuUrl.substr(0, 2) == "//"
  ) {
    window.open(item.menuUrl);
  } else {
    router.push({
      path: item.menuUrl,
      query: { uuid: item.uuid },
    });
  }
};

const godetail = (item: any) => {
  if (item.newsType === 2) {
    window.open(item.redUrl);
  } else {
    router.push({
      path: "/infoShow/" + item.nodeNum,
      query: { uuid: item.uuid },
    });
  }
};

onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goHome()))
          }, _hoisted_6),
          _hoisted_7
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", { class: "bottom" }, [
      _createElementVNode("div", {
        class: "box",
        onClick: goOther
      }, _hoisted_11),
      _createElementVNode("div", {
        class: "box",
        onClick: goOther
      }, _hoisted_14)
    ])
  ]))
}
}

})